/**
 * Created by olga on 06.10.2026
 */

Reward.register("noAds", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.noads_png;
    },

    getPrice: function (value) {
        const hardPrice = Product.CalcHardPrice("noAds");
        return hardPrice ? (hardPrice - (Products.noAds.reward.hard || 0)) * value : 0;
    },

    receive: function () {
        cleverapps.noAds.enable();
    }
});
